import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BookOnlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"book_online"}/>
}
